import { Component, OnInit } from '@angular/core';

import { Agency } from '../../shared/data/models/collections/agency';
import { CollectionsService } from '../../shared/data/services/collections.service';
import { Request } from '../../shared/data/services/request-enum';

declare const Calendly: any;
@Component({
  selector: 'placeme-agencies',
  templateUrl: './agencies.component.html',
  styleUrls: ['./agencies.component.scss'],
})
export class AgenciesComponent implements OnInit {
  agencies: Agency[];

  constructor(private collectionsService: CollectionsService) {}

  calendly(url: string): void {
    Calendly.initPopupWidget({ url });
  }

  ngOnInit(): void {
    this.collectionsService.query<{ agencies: Agency[] }>(Request.AGENCIES).subscribe(data => (this.agencies = data.agencies));
  }
}
